import { CSSVALUEPREFIX } from '../../config/constants';

import { isNumber } from './isNumber';

/**
 * Get CSS custom property variable of a given color string value
 *
 * @param {string} varName - Valid string value.
 * @return {string} The corresponding CSS custom property variable
 */
export function getCSSVariable(varName: string): string {
  return `var(${CSSVALUEPREFIX}${varName})`;
}

/**
 * Get CSS custom property variable of a given color string value
 *
 * @param {string|number} value - String or number value.
 * @return {string} The corresponding CSS custom property variable or the string prop value.
 */
export function getVariableGeneric(value: string | number, unit = 'px'): string {
  if (isNumber(value)) {
    return `${value}${unit}`;
  }

  return getCSSVariable(value);
}

/**
 * Get compiled CSS custom property value
 *
 * @param {string} variable - The variable name for which to get its value
 * @return {string} The corresponding value for the given CSS custom property
 */
export function getCSSVariableValue(variable: string, component: Element): string {
  const styles = getComputedStyle(component);
  return String(styles.getPropertyValue(`--${variable}`)).trim();
}
